import { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import VisaHeroSection from "./visa section/VisaHeroSection";
import TravelTipsSection from "./visa section/TravelTipsSection";
import CountryCardsSection from "./visa section/CountryCardsSection";
import WhyChooseVisa from "./visa section/WhyChooseVisa";
import VisaServicesSection from "./visa section/VisaServicesSection";
import FeaturesSection from "./visa section/FeaturesSection";

const Homepage3 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      {/* <VisaHeroSection />

      <WhyChooseVisa /> */}

      {/* Country Cards Section */}
      <CountryCardsSection />

      {/* Travel Tips Section */}
      <TravelTipsSection />

      <FeaturesSection />

      <VisaServicesSection />
    </div>
  );
};

export default Homepage3;
